"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var material_1 = require("@mui/material");
var MultiselectTextfield_1 = __importDefault(require("atomicComponents/atoms/MultiSelect/MultiselectTextfield"));
var Autocomplete_1 = require("atomicComponents/organisms/Autocomplete");
var validators_1 = require("utils/form/validators");
var FormAutocomplete = function (_a) {
    var _b = _a.input, name = _b.name, value = _b.value, onChange = _b.onChange, restFormInputProps = __rest(_b, ["name", "value", "onChange"]), autoFocus = _a.autoFocus, meta = _a.meta, options = _a.options, color = _a.color, isDisabled = _a.isDisabled, placeholder = _a.placeholder, onCreate = _a.onCreate, rest = __rest(_a, ["input", "autoFocus", "meta", "options", "color", "isDisabled", "placeholder", "onCreate"]);
    var filter = (0, material_1.createFilterOptions)();
    var filterOptions = function (opts, params) {
        var inputValue = params.inputValue;
        var filtered = filter(opts, params);
        var findPosLc = (0, Autocomplete_1.makeFindPosLc)(inputValue);
        filtered.sort(function (v1, v2) {
            if (!v1.value || !v2.value)
                return v1.value ? 1 : -1;
            return (findPosLc(v1.label) - findPosLc(v2.label)) * 2 + v1.label.localeCompare(v2.label);
        });
        // (findPosLc(v1.label) - findPosLc(v2.label)) * 2 + v1.label.localeCompare(v2.label));
        // Suggest the creation of a new value
        var isExisting = opts === null || opts === void 0 ? void 0 : opts.some(function (option) { return inputValue === option.label; });
        if (inputValue !== '' && !isExisting && onCreate) {
            filtered.push({
                label: inputValue,
                value: inputValue,
                isNew: true,
            });
        }
        var filteredWithoutSelected = filtered.filter(function (opt) { return opt.value !== value; });
        return inputValue.length < 3 && filteredWithoutSelected.length > 30
            ? filteredWithoutSelected.slice(0, 20)
            : filteredWithoutSelected;
    };
    var errorToShow = (0, validators_1.getErrorToShow)(meta);
    return ((0, jsx_runtime_1.jsx)(material_1.Autocomplete, __assign({}, rest, { options: options, filterOptions: filterOptions, color: color, disabled: isDisabled, getOptionDisabled: function () { return isDisabled || false; }, getOptionLabel: function (option) { return option.label; }, value: options.find(function (v) { return v.value === value; }), renderInput: function (inputProps) { return ((0, jsx_runtime_1.jsx)(MultiselectTextfield_1.default, __assign({ color: "primary" }, inputProps, restFormInputProps, { autoFocus: autoFocus !== null && autoFocus !== void 0 ? autoFocus : false, placeholder: placeholder, name: name, error: !!errorToShow, helperText: errorToShow, variant: "outlined" }))); }, onChange: function (event, newValue) { return onChange(newValue === null || newValue === void 0 ? void 0 : newValue.value); } })));
};
exports.default = FormAutocomplete;
